import { Form, FormInstance, Input, Select } from 'antd'
import '@/styles/compact-form.css'

export interface EventUserFormValues {
  name: string
  email: string
  mobile?: string
  designation?: string
  status: 'active' | 'inactive'
  event_role: 'owner' | 'crew'
}

interface EventUserFormProps {
  form: FormInstance<EventUserFormValues>
  roleOptions: string[]
  statusOptions: string[]
}

const toLabel = (value: string) =>
  value
    .split('_')
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(' ')

const EventUserForm = ({ form, roleOptions, statusOptions }: EventUserFormProps) => {
  return (
    <Form
      form={form}
      layout="vertical"
      requiredMark={false}
      className="compact-form"
      size="small"
    >
      <Form.Item
        name="name"
        label="Full Name"
        rules={[{ required: true, message: 'Please enter the user name' }]}
      >
        <Input placeholder="Enter name" />
      </Form.Item>

      <Form.Item
        name="email"
        label="Email"
        rules={[
          { required: true, message: 'Please enter an email' },
          { type: 'email', message: 'Please enter a valid email' },
        ]}
      >
        <Input placeholder="Enter email" />
      </Form.Item>

      <Form.Item
        name="mobile"
        label="Mobile Number"
        rules={[{ required: true, message: 'Please enter a mobile number' }]}
      >
        <Input placeholder="Enter mobile number" />
      </Form.Item>

      <Form.Item name="designation" label="Designation">
        <Input placeholder="Enter designation (optional)" />
      </Form.Item>

      <Form.Item
        name="event_role"
        label="Assigned Role"
        rules={[{ required: true, message: 'Please select a role' }]}
      >
        <Select placeholder="Select role" size="small">
          {roleOptions.map((role) => (
            <Select.Option key={role} value={role}>
              {toLabel(role)}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="status"
        label="Status"
        rules={[{ required: true, message: 'Please select a status' }]}
      >
        <Select placeholder="Select status" size="small">
          {statusOptions.map((status) => (
            <Select.Option key={status} value={status}>
              {toLabel(status)}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  )
}

export default EventUserForm
